class SettingGourmetSite {
  init() {
  }
  start() {
  }
}
export default SettingGourmetSite;



// WEBPACK FOOTER //
// ./src/js/module/SettingGourmetSite.js